"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _chunk = _interopRequireDefault(require("lodash/chunk"));

var _ResourceHelper = _interopRequireDefault(require("../../utils/ResourceHelper"));

var _ResourceMenuItem = _interopRequireDefault(require("./ResourceMenuItem"));

var _SeparatorTextLine = _interopRequireDefault(require("../SeparatorTextLine"));

var _dataAids = _interopRequireDefault(require("../../constants/dataAids"));

var _resource = require("../../constants/propTypes/resource");

var _anyResource = require("../../constants/anyResource");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RESOURCE_COUNT_ABOUT_THRESHOLD = 6;
var cellStyles = {
  display: 'flex',
  flexShrink: '1',
  flexGrow: '1',
  paddingLeft: 'xsmall',
  paddingRight: 'xsmall',
  paddingBottom: 'medium',
  maxWidth: '100%',
  flexBasis: '100%'
};
var styles = {
  wrapper: {
    marginBottom: 'medium',
    textAlign: 'center'
  },
  menuOpener: {
    fontColor: 'Highlight',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    name: {
      display: 'inline-block',
      fontColor: 'inherit'
    },
    icon: {
      marginLeft: 'xsmall',
      display: 'inline-block'
    }
  },
  grid: {
    marginTop: 'large',
    marginLeft: '-xsmall',
    marginRight: '-xsmall',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  resourceGroup: {
    'display': 'flex',
    'flexDirection': 'row',
    'width': '100%',
    'paddingRight': 0,
    'paddingBottom': 0,
    'paddingLeft': 0,
    'transition': 'max-height 2s ease',
    '@xs-only': {
      'flexDirection': 'column'
    }
  },
  resourceGroupTruncated: {
    'maxHeight': '200px',
    '@sm': {
      maxHeight: '110px'
    }
  },
  resourceGroupExpanded: {
    'maxHeight': '1000px',
    '@sm': {
      maxHeight: '1000px'
    }
  },
  resource: {
    'width': '100%',
    'paddingRight': 'xsmall',
    'marginBottom': 'medium',
    'paddingLeft': 'xsmall',
    '@sm': {
      width: '50%'
    }
  },
  cellSm50Pull25: _objectSpread({}, cellStyles, {
    '@sm': {
      marginLeft: '25%',
      maxWidth: '50%',
      flexBasis: '50%'
    }
  }),
  separator: {
    marginHorizontal: 'xsmall',
    paddingBottom: 'medium'
  }
};
var ResourceMenuItemHeight = 175;

var groupStyles = function groupStyles(_ref) {
  var isMoreLinkVisible = _ref.isMoreLinkVisible,
      isExpanded = _ref.isExpanded;
  var baseStyle = styles.resourceGroup;

  if (isExpanded) {
    return _objectSpread({}, baseStyle, {}, styles.resourceGroupExpanded);
  }

  if (isMoreLinkVisible) {
    return _objectSpread({}, baseStyle, {}, styles.resourceGroupTruncated);
  }

  return baseStyle;
};

var ResourceMenu = /*#__PURE__*/function (_Component) {
  _inherits(ResourceMenu, _Component);

  var _super = _createSuper(ResourceMenu);

  function ResourceMenu(props) {
    var _this;

    _classCallCheck(this, ResourceMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClickExpand", function (groupId) {
      return function () {
        var expandedGroups = _this.state.expandedGroups;

        _this.setState({
          expandedGroups: [].concat(_toConsumableArray(expandedGroups), [groupId])
        });
      };
    });

    _this.toggleResourceMenu = _this.toggleResourceMenu.bind(_assertThisInitialized(_this));
    _this.onResourceClick = _this.onResourceClick.bind(_assertThisInitialized(_this));
    _this.state = {
      isResourceMenuVisible: false,
      expandedGroups: []
    };
    return _this;
  }

  _createClass(ResourceMenu, [{
    key: "toggleResourceMenu",
    value: function toggleResourceMenu() {
      var isResourceMenuVisible = this.state.isResourceMenuVisible;
      this.setState({
        isResourceMenuVisible: !isResourceMenuVisible
      });
    }
  }, {
    key: "onResourceClick",
    value: function onResourceClick(resource) {
      this.props.onResourceClick(resource);
      this.toggleResourceMenu();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _UX2$Element = _guacWidgetCore.UX2.Element,
          Block = _UX2$Element.Block,
          MoreLink = _UX2$Element.MoreLink;
      var isResourceMenuVisible = this.state.isResourceMenuVisible;
      var _this$props = this.props,
          resources = _this$props.resources,
          selectedResource = _this$props.selectedResource,
          i18n = _this$props.i18n;
      var isMoreLinkVisible = resources.length > RESOURCE_COUNT_ABOUT_THRESHOLD;
      var resourceGroups = (0, _chunk["default"])(resources, 2);
      var menuStyles = {
        'transition': 'max-height 0.5s',
        'overflow': 'hidden',
        '@xs-only': {
          maxHeight: isResourceMenuVisible ? resources.length * ResourceMenuItemHeight + ResourceMenuItemHeight + 'px' : '0px'
        },
        '@sm': {
          maxHeight: isResourceMenuVisible ? Math.ceil(resources.length / 2) * ResourceMenuItemHeight + ResourceMenuItemHeight + 'px' : '0px'
        },
        '@md': {
          paddingHorizontal: 'large'
        },
        '@lg': {
          paddingHorizontal: 'xlarge'
        }
      };
      return /*#__PURE__*/_react["default"].createElement(Block, {
        style: styles.wrapper
      }, /*#__PURE__*/_react["default"].createElement(MoreLink.Menu, {
        onClick: this.toggleResourceMenu,
        "data-aid": _dataAids["default"].RESOURCE_MENU_OPENER,
        expanded: isResourceMenuVisible,
        tag: "span"
      }, _ResourceHelper["default"].getName(selectedResource, {
        anyResourceName: i18n.anyResourceHeader,
        ownerResourceName: i18n.ownerResourceHeader
      })), /*#__PURE__*/_react["default"].createElement(Block, {
        style: menuStyles
      }, /*#__PURE__*/_react["default"].createElement(Block, {
        style: styles.grid
      }, /*#__PURE__*/_react["default"].createElement(Block, {
        style: styles.cellSm50Pull25
      }, /*#__PURE__*/_react["default"].createElement(_ResourceMenuItem["default"], {
        resource: (0, _anyResource.anyResource)(i18n),
        onResourceClick: this.onResourceClick,
        i18n: i18n
      })), /*#__PURE__*/_react["default"].createElement(_SeparatorTextLine["default"], {
        text: i18n.resourceSeparatorLine,
        separatorStyles: styles.separator
      }), resourceGroups.map(function (group) {
        var isExpanded = _this2.state.expandedGroups.some(function (id) {
          return id === group[0].id;
        });

        return /*#__PURE__*/_react["default"].createElement(Block, {
          key: "group-".concat(group[0].id),
          style: groupStyles({
            isMoreLinkVisible: isMoreLinkVisible,
            isExpanded: isExpanded
          })
        }, group.map(function (resource) {
          return /*#__PURE__*/_react["default"].createElement(Block, {
            key: resource.id,
            style: styles.resource
          }, /*#__PURE__*/_react["default"].createElement(_ResourceMenuItem["default"], {
            resource: resource,
            isMoreLinkVisible: isMoreLinkVisible,
            onResourceClick: _this2.onResourceClick,
            onClickMore: _this2.onClickExpand(group[0].id),
            i18n: i18n
          }));
        }));
      }))));
    }
  }]);

  return ResourceMenu;
}(_react.Component);

exports["default"] = ResourceMenu;
ResourceMenu.propTypes = {
  resources: _propTypes["default"].arrayOf(_resource.resourcePropType.isRequired).isRequired,
  onResourceClick: _propTypes["default"].func.isRequired,
  selectedResource: _propTypes["default"].object.isRequired,
  i18n: _propTypes["default"].object.isRequired
};